import { render, staticRenderFns } from "./CustomersIndex.vue?vue&type=template&id=152df69c"
import script from "./CustomersIndex.vue?vue&type=script&lang=js"
export * from "./CustomersIndex.vue?vue&type=script&lang=js"
import style0 from "./CustomersIndex.vue?vue&type=style&index=0&id=152df69c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports